import * as React from "react";
import { SVGProps } from "react";
const SvgSmartphoneChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 3h-8C9.8 3 8 4.8 8 7v18c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4V7c0-2.2-1.8-4-4-4Zm2 22c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-3h12v3Zm-6 1c.8 0 1.5-.7 1.5-1.5S16.8 23 16 23s-1.5.7-1.5 1.5.7 1.5 1.5 1.5Zm4.293-16.494a1 1 0 0 1 1.497 1.32l-.083.095-6 6a1 1 0 0 1-1.32.083l-.094-.083-2.73-2.73a1 1 0 0 1 1.32-1.497l.094.083L15 14.799l5.293-5.293Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSmartphoneChecked;
